<template>
  <ContentWrap>
    <el-alert
      title="从本店在售商品导入直播库，关联审核通过的主播才可选用。售价、库存和佣金沿用现有商品及佣金规则。"
      type="info"
      :closable="false"
      class="mb-12px"
    />
    <el-form inline @submit.prevent="search">
      <el-form-item label="商品名称"
        ><el-input
          v-model="query.keyword"
          clearable
          placeholder="搜索直播商品"
          @keyup.enter="search"
      /></el-form-item>
      <el-form-item
        ><el-button @click="search">搜索</el-button
        ><el-button type="primary" @click="openImport">导入商品</el-button></el-form-item
      >
    </el-form>
    <el-table :data="list" v-loading="loading">
      <el-table-column prop="id" label="商品编号" width="100" />
      <el-table-column prop="name" label="商品名称" min-width="220" />
      <el-table-column label="售价（元）" width="120"
        ><template #default="{ row }">{{ yuan(row.price) }}</template></el-table-column
      >
      <el-table-column prop="stock" label="库存" width="100" />
      <el-table-column label="商品状态" width="130"
        ><template #default="{ row }"
          ><el-tag :type="row.status === 1 ? 'success' : 'info'">{{
            row.status === 1 ? '在售' : '不可选用'
          }}</el-tag></template
        ></el-table-column
      >
      <el-table-column label="操作" width="120"
        ><template #default="{ row }"
          ><el-button link type="danger" @click="remove(row.id)">移出直播库</el-button></template
        ></el-table-column
      >
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>
  <el-dialog v-model="visible" title="导入本店商品" width="800px">
    <el-form inline @submit.prevent="searchCandidates">
      <el-form-item label="商品名称"
        ><el-input v-model="candidate.name" clearable @keyup.enter="searchCandidates"
      /></el-form-item>
      <el-form-item><el-button @click="searchCandidates">搜索</el-button></el-form-item>
    </el-form>
    <el-table
      :data="candidates"
      v-loading="candidateLoading"
      @selection-change="selection = $event.map((row) => row.id)"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="name" label="商品名称" min-width="220" />
      <el-table-column label="售价（元）"
        ><template #default="{ row }">{{ yuan(row.price) }}</template></el-table-column
      >
      <el-table-column prop="stock" label="库存" />
    </el-table>
    <Pagination
      v-model:page="candidate.pageNo"
      v-model:limit="candidate.pageSize"
      :total="candidateTotal"
      @pagination="loadCandidates"
    />
    <template #footer
      ><el-button @click="visible = false">取消</el-button
      ><el-button
        type="primary"
        :disabled="!selection.length"
        :loading="saving"
        @click="confirmImport"
        >导入选中商品（{{ selection.length }}）</el-button
      ></template
    >
  </el-dialog>
</template>
<script setup lang="ts">
import * as LiveApi from '@/api/merchant/live'
import * as ProductApi from '@/api/merchant/product'
defineOptions({ name: 'MerchantLiveProduct' })
interface Product {
  id: number
  name: string
  price: number
  stock: number
  status: number
}
const message = useMessage()
const query = reactive({ keyword: '', pageNo: 1, pageSize: 10 })
const candidate = reactive({ name: '', pageNo: 1, pageSize: 10, tabType: 0 })
const list = ref<Product[]>([]),
  candidates = ref<Product[]>([])
const total = ref(0),
  candidateTotal = ref(0)
const loading = ref(false),
  candidateLoading = ref(false),
  saving = ref(false),
  visible = ref(false)
const selection = ref<number[]>([])
const yuan = (price: number) => ((price || 0) / 100).toFixed(2)
const load = async () => {
  loading.value = true
  try {
    const r = await LiveApi.getLiveProductPage(query)
    list.value = r.list
    total.value = r.total
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  return load()
}
const loadCandidates = async () => {
  candidateLoading.value = true
  selection.value = []
  try {
    const r = await ProductApi.getSpuPage(candidate)
    candidates.value = r.list
    candidateTotal.value = r.total
  } finally {
    candidateLoading.value = false
  }
}
const searchCandidates = () => {
  candidate.pageNo = 1
  return loadCandidates()
}
const openImport = async () => {
  visible.value = true
  candidate.name = ''
  candidate.pageNo = 1
  await loadCandidates()
}
const confirmImport = async () => {
  saving.value = true
  try {
    const count = await LiveApi.importLiveProducts(selection.value)
    message.success(`已导入 ${count} 件商品，重复商品自动跳过`)
    visible.value = false
    await load()
  } finally {
    saving.value = false
  }
}
const remove = async (id: number) => {
  await message.confirm('移出后主播将不能再选用该商品，商城商品和库存会保留。')
  await LiveApi.removeLiveProduct(id)
  await load()
}
onMounted(load)
</script>
